import React from 'react';
export function FactoryIssueReportTemplate() {
  return <div style={{
    fontFamily: 'Arial, sans-serif',
    maxWidth: '600px',
    margin: '0 auto'
  }} data-id="element-408">
      {/* Header with logo */}
      <div style={{
      textAlign: 'center',
      padding: '32px 0'
    }} data-id="element-409">
        <img src="https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/hnodgoqduyba7n8dlqxg6c/d4d40573-a6d5-4127-bafb-e288840a0b5f/AISCO_WORKSPACE_MARCA_POSITIVO.svg" alt="Aisco Workspace" style={{
        height: '40px',
        display: 'inline-block'
      }} data-id="element-410" />
      </div>

      {/* Main content */}
      <div style={{
      backgroundColor: '#ffffff',
      padding: '40px 32px'
    }} data-id="element-411">
        <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        marginBottom: '24px',
        gap: '12px'
      }} data-id="element-412">
          <div data-id="element-413">
            <h1 style={{
            fontSize: '24px',
            fontWeight: '600',
            color: '#1f2937',
            margin: '0 0 8px 0'
          }} data-id="element-414">
              Technical issue report
            </h1>
            <span style={{
            fontSize: '12px',
            fontWeight: '600',
            color: '#d97706',
            backgroundColor: '#fef3c7',
            padding: '4px 10px',
            borderRadius: '4px',
            border: '1px solid #fbbf24',
            textTransform: 'uppercase',
            letterSpacing: '0.5px'
          }} data-id="element-415">
              Internal Report
            </span>
          </div>
          <span style={{
          fontSize: '13px',
          fontWeight: '600',
          color: '#2563eb',
          backgroundColor: '#eff6ff',
          padding: '4px 12px',
          borderRadius: '4px',
          border: '1px solid #bfdbfe',
          whiteSpace: 'nowrap'
        }} data-id="element-416">
            FR-2025-001
          </span>
        </div>

        <p style={{
        fontSize: '16px',
        color: '#4b5563',
        lineHeight: '1.6',
        marginBottom: '32px'
      }} data-id="element-417">
          A new technical issue report has been submitted by{' '}
          <strong data-id="element-418">Aisco Europe</strong> regarding a recurrent technical problem
          that requires factory review and action.
        </p>

        {/* Report Notice */}
        <div style={{
        backgroundColor: '#fef3c7',
        padding: '20px',
        borderRadius: '8px',
        borderLeft: '4px solid #f59e0b',
        marginBottom: '32px'
      }} data-id="element-419">
          <h3 style={{
          fontSize: '16px',
          fontWeight: '600',
          color: '#92400e',
          marginTop: '0',
          marginBottom: '8px'
        }} data-id="element-420">
            ⚠ Factory Review Required
          </h3>
          <p style={{
          margin: '0',
          color: '#b45309',
          fontSize: '14px',
          lineHeight: '1.6'
        }} data-id="element-421">
            This report identifies a design or recurrent issue that requires
            factory investigation and potential corrective action.
          </p>
        </div>

        {/* Report Details */}
        <div style={{
        backgroundColor: '#f9fafb',
        padding: '20px',
        borderRadius: '8px',
        border: '1px solid #e5e7eb',
        marginBottom: '24px'
      }} data-id="element-422">
          <h3 style={{
          fontSize: '14px',
          fontWeight: '600',
          color: '#6b7280',
          marginTop: '0',
          marginBottom: '16px',
          textTransform: 'uppercase',
          letterSpacing: '0.5px'
        }} data-id="element-423">
            Report Information
          </h3>
          <div style={{
          display: 'grid',
          gap: '12px'
        }} data-id="element-424">
            <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            fontSize: '14px',
            lineHeight: '1.6'
          }} data-id="element-425">
              <span style={{
              color: '#6b7280'
            }} data-id="element-426">
                Reported By:
              </span>
              <span style={{
              color: '#1f2937',
              fontWeight: '500'
            }} data-id="element-427">
                Ing Regis Simier
              </span>
            </div>
            <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            fontSize: '14px',
            lineHeight: '1.6'
          }} data-id="element-428">
              <span style={{
              color: '#6b7280'
            }} data-id="element-429">
                Business Unit:
              </span>
              <span style={{
              color: '#1f2937',
              fontWeight: '500'
            }} data-id="element-430">
                Aisco Europe
              </span>
            </div>
            <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            fontSize: '14px',
            lineHeight: '1.6'
          }} data-id="element-431">
              <span style={{
              color: '#6b7280'
            }} data-id="element-432">
                Report Date:
              </span>
              <span style={{
              color: '#1f2937',
              fontWeight: '500'
            }} data-id="element-433">
                January 15, 2025
              </span>
            </div>
            <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            fontSize: '14px',
            lineHeight: '1.6'
          }} data-id="element-434">
              <span style={{
              color: '#6b7280'
            }} data-id="element-435">
                Issue Type:
              </span>
              <span style={{
              color: '#1f2937',
              fontWeight: '500'
            }} data-id="element-436">
                Recurrent Problem
              </span>
            </div>
            <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            fontSize: '14px',
            lineHeight: '1.6',
            alignItems: 'center'
          }} data-id="element-437">
              <span style={{
              color: '#6b7280'
            }} data-id="element-438">
                Severity:
              </span>
              <span style={{
              fontSize: '12px',
              fontWeight: '600',
              color: '#dc2626',
              backgroundColor: '#fee2e2',
              padding: '3px 10px',
              borderRadius: '4px'
            }} data-id="element-439">
                HIGH
              </span>
            </div>
          </div>
        </div>

        {/* Affected Models */}
        <div style={{
        backgroundColor: '#f9fafb',
        padding: '20px',
        borderRadius: '8px',
        border: '1px solid #e5e7eb',
        marginBottom: '24px'
      }} data-id="element-440">
          <h3 style={{
          fontSize: '14px',
          fontWeight: '600',
          color: '#6b7280',
          marginTop: '0',
          marginBottom: '16px',
          textTransform: 'uppercase',
          letterSpacing: '0.5px'
        }} data-id="element-441">
            Affected Models
          </h3>
          <div style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '8px'
        }} data-id="element-442">
            <p style={{
            margin: '0',
            fontSize: '14px',
            color: '#1f2937',
            fontFamily: 'monospace',
            backgroundColor: '#ffffff',
            padding: '8px 12px',
            borderRadius: '4px',
            border: '1px solid #e5e7eb'
          }} data-id="element-443">
              Pivot CP-600
            </p>
            <p style={{
            margin: '0',
            fontSize: '14px',
            color: '#1f2937',
            fontFamily: 'monospace',
            backgroundColor: '#ffffff',
            padding: '8px 12px',
            borderRadius: '4px',
            border: '1px solid #e5e7eb'
          }} data-id="element-444">
              Pivot 8120
            </p>
          </div>
        </div>

        {/* Issue Description */}
        <div style={{
        backgroundColor: '#eff6ff',
        padding: '20px',
        borderRadius: '8px',
        borderLeft: '4px solid #2563eb',
        marginBottom: '24px'
      }} data-id="element-445">
          <h3 style={{
          fontSize: '14px',
          fontWeight: '600',
          color: '#1e40af',
          marginTop: '0',
          marginBottom: '12px',
          textTransform: 'uppercase',
          letterSpacing: '0.5px'
        }} data-id="element-446">
            Issue Description
          </h3>
          <p style={{
          margin: '0 0 16px 0',
          color: '#1e40af',
          fontSize: '14px',
          lineHeight: '1.8'
        }} data-id="element-447">
            Multiple dealers have reported recurring failures in the hydraulic
            pressure valve system after approximately 6-8 months of operation.
            The issue appears to be related to a design flaw in the seal
            mechanism that causes premature wear under high-pressure conditions.
            This has resulted in 12 warranty claims across 3 different regions
            in the past quarter.
          </p>
        </div>

        {/* Recommended Action */}
        <div style={{
        backgroundColor: '#f9fafb',
        padding: '20px',
        borderRadius: '8px',
        border: '1px solid #e5e7eb',
        marginBottom: '32px'
      }} data-id="element-448">
          <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '12px'
        }} data-id="element-449">
            <h3 style={{
            fontSize: '14px',
            fontWeight: '600',
            color: '#6b7280',
            margin: '0',
            textTransform: 'uppercase',
            letterSpacing: '0.5px'
          }} data-id="element-450">
              Recommended Action
            </h3>
            <span style={{
            fontSize: '12px',
            color: '#6b7280',
            fontStyle: 'italic'
          }} data-id="element-451">
              by Ing. Regis Simier
            </span>
          </div>
          <p style={{
          margin: '0',
          color: '#4b5563',
          fontSize: '14px',
          lineHeight: '1.8'
        }} data-id="element-452">
            Immediate engineering review of the seal design is recommended.
            Consider implementing a reinforced seal material or redesigning the
            valve housing to reduce pressure stress points. A technical bulletin
            should be issued to all Business Units once a solution is
            identified.
          </p>
        </div>

        {/* CTA Button */}
        <div style={{
        textAlign: 'center',
        margin: '32px 0'
      }} data-id="element-453">
          <a href="#" style={{
          display: 'inline-block',
          backgroundColor: '#2563eb',
          color: '#ffffff',
          padding: '14px 32px',
          borderRadius: '8px',
          textDecoration: 'none',
          fontSize: '16px',
          fontWeight: '600'
        }} data-id="element-454">
            Review issue report
          </a>
        </div>

        <p style={{
        fontSize: '14px',
        color: '#6b7280',
        lineHeight: '1.6',
        marginTop: '32px',
        marginBottom: '0',
        textAlign: 'center'
      }} data-id="element-455">
          This is an internal report. Please review and coordinate with the
          factory team through Aisco Workspace.
        </p>
      </div>

      {/* Footer */}
      <div style={{
      backgroundColor: '#f9fafb',
      padding: '24px 32px',
      borderTop: '1px solid #e5e7eb',
      textAlign: 'center'
    }} data-id="element-456">
        <p style={{
        fontSize: '12px',
        color: '#6b7280',
        lineHeight: '1.5',
        margin: '0'
      }} data-id="element-457">
          Aisco Europe S.A.U • Calle Playa de Riazor 22, 28042
          <br data-id="element-458" />
          Madrid, Spain
        </p>
      </div>
    </div>;
}